function Veganly(): JSX.Element {
  return (
    <div>
      Veganly is a line of items at Huetown. More details soon!
    </div>
  );
}

export default Veganly;
